// Dialpad's Mini Dialer sends no microphone audio outside Chromium, even in
// Dialpad's own dialer. Every Chromium browser carries "Chrome/" in its user
// agent; Safari, Firefox and all iOS browsers do not. Deliberately loose: it
// blocks the engines known not to work, not every browser but Google Chrome.
export function isSupportedDialpadBrowser(
  userAgent: string = navigator.userAgent
): boolean {
  return userAgent.includes("Chrome/");
}
